// extracted by mini-css-extract-plugin
module.exports = {"FaqAskQuestion":"pa_a bhv_px bhv_a bhv_w","FaqAskQuestion__outdated":"pa_b bhv_ul bhv_vz"};